import {useEffect,useState} from 'react';
import {getAuthToken} from './authSession';
export const workflowPaths:Record<string,string>={
 predeclarations:'/declarations/predeclarations',drafts:'/declarations/drafts',submitted:'/declarations/submitted',validated:'/declarations/validated',
 justifications:'/justifications',taxations:'/taxations','debit-notes':'/fpt/debit-notes','to-pay':'/payments/to-pay','in-progress':'/payments/in-progress',partial:'/payments/partial',pending:'/payments/pending',paid:'/payments/paid',proofs:'/payments/proofs',receipts:'/fpt/quittances',
};
export function useWorkflowCounts(){
 const [counts,setCounts]=useState<Record<string,number>>({});
 const [error,setError]=useState('');
 useEffect(()=>{
  let alive=true,sequence=0;let controller:AbortController|undefined;
  const refresh=async()=>{
   const seq=++sequence;controller?.abort();controller=new AbortController();
   try{
    const r=await fetch(`${import.meta.env.VITE_API_BASE_URL||''}/api/v1/fpt/month-end/navigation`,{headers:{Authorization:`Bearer ${getAuthToken()}`},signal:controller.signal});
    if(!r.ok)throw new Error('Compteurs FPT indisponibles');
    const data=await r.json();
    if(!data||Array.isArray(data)||Object.keys(workflowPaths).some(key=>!Number.isSafeInteger(data[key])||data[key]<0))throw new Error('Compteurs FPT indisponibles');
    if(alive&&seq===sequence){setCounts(Object.fromEntries(Object.keys(workflowPaths).map(key=>[key,data[key]])));setError('')}
   }catch{if(alive&&seq===sequence){setCounts({});setError('Compteurs FPT indisponibles. Les pages restent accessibles.')}}
  };
  void refresh();const timer=setInterval(refresh,30000);
  window.addEventListener('fpt-workflow-changed',refresh);window.addEventListener('focus',refresh);
  return()=>{alive=false;controller?.abort();clearInterval(timer);window.removeEventListener('fpt-workflow-changed',refresh);window.removeEventListener('focus',refresh)};
 },[]);
 return {counts,error};
}
